import Editor from '@monaco-editor/react';
import { useAppSelector } from '../app/hooks';
import { selectTheme } from '../features/ui/uiSlice';
import { monacoLanguageOf } from './monacoLanguage';

export interface PasteEditorProps {
  readonly value: string;
  readonly language: string;
  readonly label: string;
  readonly onChange?: (value: string) => void;
  readonly readOnly?: boolean;
}

/** Monaco-based editor/viewer for paste content; fills its container. */
export function PasteEditor({ value, language, label, onChange, readOnly = false }: PasteEditorProps) {
  const theme = useAppSelector(selectTheme);
  return (
    <div className="paste-editor" role="group" aria-label={label}>
      <Editor
        value={value}
        language={monacoLanguageOf(language)}
        height="100%"
        theme={theme === 'dark' ? 'vs-dark' : 'vs'}
        onChange={(next) => onChange?.(next ?? '')}
        options={{
          readOnly,
          domReadOnly: readOnly,
          ariaLabel: label,
          automaticLayout: true,
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          wordWrap: 'on',
          fontSize: 14,
          padding: { top: 12 },
        }}
      />
    </div>
  );
}
